import { render, staticRenderFns } from "./HelpDeskConversations.vue?vue&type=template&id=3b58716a&"
import script from "./HelpDeskConversations.vue?vue&type=script&lang=js&"
export * from "./HelpDeskConversations.vue?vue&type=script&lang=js&"
import style0 from "./HelpDeskConversations.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports